import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  Fade,
  Grow,
  Slide,
} from "@mui/material";
import { useState } from "react";
import { motion } from "framer-motion";

const ScheduleForm = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSuccess = () => {
    setIsSubmitted(true);
  };

  return (
    <div className="w-full px-4 py-16 bg-[#d2e5e4] flex justify-center items-center">
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-3xl bg-white shadow-xl rounded-xl p-6 md:p-10"
      >
        {isSubmitted ? (
          <Fade in={isSubmitted}>
            <div className="flex flex-col items-center text-center space-y-4">
              <motion.div
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ duration: 1, repeat: Infinity }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-16 w-16 text-green-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </motion.div>
              <Typography variant="h4" className="font-bold">
                Thank You!!
              </Typography>
              <Typography variant="body1">
                We've received your request and will contact you shortly.
              </Typography>
            </div>
          </Fade>
        ) : (
          <>
            <Slide direction="down" in={!isSubmitted} mountOnEnter unmountOnExit>
              <div className="text-center mb-6">
                <Typography variant="h4" className="font-bold">
                  Schedule Your Free Demo
                </Typography>
                <Typography variant="subtitle1" className="text-gray-600 mt-2">
                  Experience the future of healthcare technology
                </Typography>
              </div>
            </Slide>

            <form
              action="https://formspree.io/f/xzzvengg"
              method="POST"
              onSubmit={() => setTimeout(handleSuccess, 1000)}
            >
              <input type="hidden" name="_subject" value="New Demo Request" />

              <div className="grid gap-4">
                <Grow in>
                  <TextField
                    fullWidth
                    name="name"
                    label="Your Name"
                    required
                    variant="filled"
                    margin="normal"
                  />
                </Grow>

                <Grow in style={{ transitionDelay: "100ms" }}>
                  <TextField
                    fullWidth
                    name="email"
                    label="Email"
                    type="email"
                    required
                    variant="filled"
                    margin="normal"
                  />
                </Grow>

                <Grow in style={{ transitionDelay: "200ms" }}>
                  <TextField
                    fullWidth
                    name="phone"
                    label="Phone Number"
                    required
                    variant="filled"
                    margin="normal"
                  />
                </Grow>

                <Grow in style={{ transitionDelay: "250ms" }}>
                  <TextField
                    fullWidth
                    name="hospital"
                    label="Hospital Name"
                    required
                    variant="filled"
                    margin="normal"
                  />
                </Grow>

                <Grow in style={{ transitionDelay: "300ms" }}>
                  <FormControl fullWidth margin="normal" variant="filled">
                    <InputLabel>Select a Product</InputLabel>
                      <Select name="product" defaultValue="MedOps" required>
                        <MenuItem value="MedOps">MedOps</MenuItem>
                      <MenuItem value="Pharmaconnect">Pharmaconnect</MenuItem>
                    </Select>
                  </FormControl>
                </Grow>

                <Grow in style={{ transitionDelay: "400ms" }}>
                  <TextField
                    fullWidth
                    name="message"
                    label="Your Message"
                    multiline
                    rows={4}
                    variant="filled"
                    margin="normal"
                  />
                </Grow>

                <Grow in style={{ transitionDelay: "500ms" }}>
                  <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      className="w-full bg-blue-600 text-white hover:bg-blue-700 transition-all duration-300"
                    >
                      SCHEDULE A FREE DEMO
                    </Button>
                  </motion.div>
                </Grow>
              </div>
            </form>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default ScheduleForm;
